import { Encoder, MGPOptional } from '@everyboard/lib';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { Orthogonal } from '../../jscaip/Orthogonal';
export class SiamMove extends MoveCoord {
    direction;
    landingOrientation;
    static encoder = Encoder.tuple([
        Encoder.identity(), // x
        Encoder.identity(), // y
        MGPOptional.getEncoder(Orthogonal.encoder), // direction
        Orthogonal.encoder, // orientation
    ], (m) => [m.coord.x, m.coord.y, m.direction, m.landingOrientation], (fields) => SiamMove.of(fields[0], fields[1], fields[2], fields[3]));
    constructor(x, y, direction, landingOrientation) {
        super(x, y);
        this.direction = direction;
        this.landingOrientation = landingOrientation;
    }
    static of(x, y, direction, landingOrientation) {
        return new SiamMove(x, y, direction, landingOrientation);
    }
    isRotation() {
        return this.direction.isAbsent();
    }
    equals(other) {
        if (this === other)
            return true;
        if (this.coord.equals(other.coord) === false)
            return false;
        if (this.direction.equals(other.direction) === false)
            return false;
        return this.landingOrientation === other.landingOrientation;
    }
    toString() {
        const moveDirection = this.direction.isAbsent() ? '-' : this.direction.get().toString();
        return 'SiamMove(' + this.coord.x + ', ' +
            this.coord.y + ', ' +
            moveDirection + ', ' +
            this.landingOrientation + ')';
    }
}
